// extracted by mini-css-extract-plugin
export default {"container":"QKuLI","image":"_d6St","dropzone":"vBrc1","hidden":"Hih3T","hovered":"lhv29"};